import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  BLAST_SEPOLIA = 168587773,
  BLAST_MAINNET = 81457
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

export const FACTORY_ADDRESS = {
  [ChainId.BLAST_SEPOLIA]: '0x11a216c083A1b3bcC77C353e63Ce556823f825C9',
  [ChainId.BLAST_MAINNET]: '0xb4A7D971D0ADea1c73198C97d7ab3f9CE4aaFA13'
}

export const INIT_CODE_HASH = {
  [ChainId.BLAST_SEPOLIA]: '0xc000ec5c74ba673d0eb756e215a5cd5acc42369b5950d8bec1e915e5e524be24',
  [ChainId.BLAST_MAINNET]: '0x6f0346418750a1a53597a51ceff4f294b5f0e87f09715525b519d38ad3fab2cb'
}

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
